import styled from "styled-components";

export const QuantityValueContainer = styled.div`
  border: 1px solid #f4f4f4;
    border-radius: 10px;
    width: 50px;
    height: 30px;
    background: #fff;
    color: #646464;
    text-align: center;
    display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
`;